__turbopack_context__.v({
  "Address": "Locations-module-sass-module__08PhZa__Address",
  "Copy": "Locations-module-sass-module__08PhZa__Copy",
  "Email": "Locations-module-sass-module__08PhZa__Email",
  "Link": "Locations-module-sass-module__08PhZa__Link",
  "Location": "Locations-module-sass-module__08PhZa__Location",
  "Locations": "Locations-module-sass-module__08PhZa__Locations",
  "Phone": "Locations-module-sass-module__08PhZa__Phone",
  "Title": "Locations-module-sass-module__08PhZa__Title",
});
